import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { PaymentsModule } from './payments/payments.module';
import { PlanningNewComponent } from './planning-new/planning-new.component';
import { PlanningViewComponent } from './planning-view/planning-view.component';

const routes: Routes = [
  {
    path: '',
    redirectTo : 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    pathMatch: 'full'
  },
  {
    path: 'bookings',
    loadChildren: () => import('./bookings/bookings.module').then(m => m.BookingsModule)
  },
  {
    path: 'stores',
    loadChildren: () => import('./stores/stores.module').then(m => m.StoresModule)
  },
  {
    path: 'products',
    loadChildren: () => import('./products-services/products-services.module').then(m => m.ProductsServicesModule)
  },
  {
    path: 'payments',
    loadChildren: () => import('./payments/payments.module').then(m =>PaymentsModule)
  },
  {
    path: 'planning',
    component: PlanningViewComponent,
    pathMatch: 'full'
  },
  {
    path: 'planningold',
    component: PlanningNewComponent,
    pathMatch: 'full'
  },
  {
    path: 'inventories',
    loadChildren: () => import('./inventories/inventories.module').then(m => m.InventoriesModule)
  },
  {
    path: 'graphics',
    loadChildren: () => import('./graphs/graphs.module').then(m => m.GraphsModule)
  },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
